import { ActionType } from 'interfaces/generic';
import { TExternalJackpot, TJackpotMeta } from 'interfaces/jackpot';
import { JackpotActionTypes } from 'store/action-types/jackpot';

type TInitialState = {
  currentJackpotId: Record<string, number | null>;
  jackpotMetaData: Record<string, Record<string, TJackpotMeta[]>>;
  internalJackpots?: {
    casino: number[];
    bet: number[];
  };
  externalJackpots: TExternalJackpot[] | null;
};

const initialState: TInitialState = {
  currentJackpotId: {},
  jackpotMetaData: {},
  externalJackpots: null
};

export const jackpot = (
  state = initialState,
  action: ActionType
): TInitialState => {
  switch (action.type) {
    case JackpotActionTypes.SET_CURRENT_JACKPOT_ID:
      return {
        ...state,
        currentJackpotId: {
          ...state.currentJackpotId,
          ...action.payload
        }
      };
    case JackpotActionTypes.SET_JACKPOT_META_DATA:
      return {
        ...state,
        jackpotMetaData: {
          ...state.jackpotMetaData,
          ...{
            [action.payload.moduleId]: {
              ...state.jackpotMetaData[action.payload.moduleId],
              [action.payload.jackpotId]: action.payload.jackpotData
            }
          }
        }
      };
    case JackpotActionTypes.SET_INTERNAL_JACKPOTS:
      return {
        ...state,
        internalJackpots: action.payload
      };

    case JackpotActionTypes.SET_EXTERNAL_JACKPOTS:
      return {
        ...state,
        externalJackpots: action.payload
      };

    default: {
      return state;
    }
  }
};
